<template>
  <section class="bg_color">
    <h2>コラム記事一覧</h2>
    <section class="inner">
      <ul class="column_list">
        <li class="column_card" v-for="article in articles" :key="article.id">
          <router-link
            :to="{ name: 'ColumnDetail', params: { id: article.id } }"
            class="column_card_link"
          >
            <div class="card_author" :class="article.colorClass">
              <div class="card_author_img">
                <img :src="article.img" :alt="article.name" />
              </div>
            </div>
            <div class="card_body">
              <p class="card_date">{{ article.date }}</p>
              <p class="card_title">{{ article.title }}</p>
              <p class="card_more">詳細を見る</p>
            </div>
          </router-link>
        </li>
      </ul>
    </section>
  </section>
</template>

<script>
import takahashi from "@/assets/images/column/takahashi.jpg";
import oota from "@/assets/images/column/oota.jpg";
import nissiD from "@/assets/images/column/nissi_D.jpg";

export default {
  name: "ColumnList",
  data() {
    return {
      articles: [
        {
          id: "6",
          role: "スポーツ報知",
          name: "太田記者さん",
          img: oota,
          colorClass: "author_green",
          date: "2026/08/31（月）",
          title: "MOG2026〜27seasonに向けて①",
        },
        {
          id: "5",
          role: "ボートレース アナウンサー",
          name: "高橋アナさん",
          img: takahashi,
          colorClass: "author_blue",
          date: "2026/05/01（金）",
          title: "ゴールデンウィーク直前のモーター状況",
        },
        {
          id: "2",
          role: "スポーツ報知",
          name: "太田記者さん",
          img: oota,
          colorClass: "author_green",
          date: "2026/04/05（日）",
          title: "SGボートレースクラシックは大盛況で幕を閉じました。",
        },
        {
          id: "1",
          role: "ボートレース アナウンサー",
          name: "高橋アナさん",
          img: takahashi,
          colorClass: "author_blue",
          date: "2026/02/20（金）",
          title: "皆様！！ボートレースを楽しんでいますか！！",
        },
        {
          id: "3",
          role: "スポーツ報知",
          name: "太田記者さん",
          img: oota,
          colorClass: "author_green",
          date: "2026/02/20（金）",
          title: "SGクラシックのパンフレットが完成しました",
        },
        {
          id: "4",
          role: "ガマステの看板D",
          name: "にっしーDさん",
          img: nissiD,
          colorClass: "author_yellow",
          date: "2026/02/20（金）",
          title: "はいどーも！にっしーです♪",
        },
      ],
    };
  },
};
</script>

<style lang="css" src="@/assets/css/style_parts.css" scoped></style>
<style lang="css" src="@/assets/css/style_column.css" scoped></style>
